import { render, staticRenderFns } from "./NumerazioniEdit.vue?vue&type=template&id=2ae4b3f2&"
import script from "./NumerazioniEdit.vue?vue&type=script&lang=ts&"
export * from "./NumerazioniEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports